import React from 'react';
import { Row, Col, List } from 'reactstrap';
import UpdateButton from '../navigation/UpdateButton';
import { NONE_ENTERED } from '../layout/DisplayUserText';
import './layout.scss';
import { OTHER_CKBX_VAL } from '../../Views/OtherCheckboxUtils';

//pass in props.values: either a single string value, or an array of strings.
//look up labels that match the values from a data structure like ConstGoalBtns (array of objects that have .value and .label attributes)
//create a <List> from those labels.
//if no lookup array provided, it just displays props.values
//The only user of this is ReviewRow, which has the job of making sure a props.skipWarning is passed in
export function ValuesList(props) {
  const {
    values,
    lookup,
    skipWarning
  } = props;

  //by default, render this as <List>. otw follow directive of props.asString
  const asString = (props.asString === undefined) ? false : props.asString;

  let noneLabel = NONE_ENTERED;

  //TODO can't get this to evaluate. it just shows the literal string, so skip it
  //const noneIcon = '<span className="fa fa-exclamation-circle">&nbsp;</span>';

  //create array of values:
  let valuesArray = [];
  if ( (typeof values === 'string') && (values)){
    valuesArray.push(values);
  }
  else if ( Array.isArray(values)){
    valuesArray = values;
  }

  //create an array of matching labels for each value,
  //preserving the order of the incoming values.
  let labels = [];
  //if no values, show 'None entered'
  if (valuesArray.length === 0)
    labels.push(noneLabel);
  else{
    if (lookup){
      valuesArray.forEach((value)=>{
        lookup.forEach((item)=>{
          if ( value.startsWith(OTHER_CKBX_VAL) && (item.value).startsWith(OTHER_CKBX_VAL)){
            labels.push(value);
          }
          else if(value === item.value){
            labels.push(item.label);
          }
        });
      });
    }
    else labels = valuesArray;
  }

  //return as a comma-delimited string if specified, otw return as <List>
  if (asString){
    return(labels.join(', ')); //toString());
  }
  return(
    <List type="unstyled" className="aa-values-list">
    {labels.map(function(item, index) { 
      return(
        <li key={index}>
          {(item === noneLabel && !skipWarning) && <span className="aa-notice-me fa fa-exclamation-triangle">&nbsp;</span>}
          {item}
        </li>
      )
    })}
    </List>
  );
}

//Presentational component to display the rows of values and Update buttons when reviewing each wizard section.
//Pass in the nextRoute via props. If no nextRoute supplied, it doesn't display an Update button.
//props.values might be one string, or an array of strings. ValuesList takes care of 'sanitizing' the props.values.
function ReviewRow(props){
  const heading = props.heading;
  const nextRoute = props.nextRoute;
  const values = props.values;
  const lookup = props.lookup;
  //by default, don't skip the warning. otw follow directive of props.skipWarning
  const skipWarning = (props.skipWarning === undefined) ? false : props.skipWarning;
  //pass in padded='none' if you don't want padding. otw you'll get padding.
  const padded = props.padded || 'true';
  const border = props.border || 'true';

  let cname = "";
  if(padded !== 'none')
    cname = cname + "aa-review-row";
  if(border !== 'none')
    cname = cname + " border-top";

  return(
    <Row className={cname}>
      <Col>
        <Row>
          <Col md="8" xs="6">
            <strong>{heading}</strong>
          </Col>
          {nextRoute
            ? <Col md="4" xs="6">
                <UpdateButton nextRoute={nextRoute} />
              </Col>
            : <></>
          }
        </Row>
        <Row>
          <Col>
            <ValuesList values={values} lookup={lookup} skipWarning={skipWarning}/>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default ReviewRow;

